/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Media_Covers1Inputs */

const id_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sampul`)
};

const ms_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulit`)
};

const da_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covere`)
};

const de_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover`)
};

const en_us2_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covers`)
};

const es_es2_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portadas`)
};

const es_mx2_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portadas`)
};

const fil_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Cover`)
};

const fr_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couvertures`)
};

const it_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copertine`)
};

const hu_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borítók`)
};

const nl_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omslagen`)
};

const no_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forsider`)
};

const pl_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okładki`)
};

const pt_br2_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capas`)
};

const pt_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capas`)
};

const ro_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coperți`)
};

const fi_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kannet`)
};

const sv_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omslag`)
};

const vi_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bìa`)
};

const tr_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapaklar`)
};

const cs_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obálky`)
};

const bg_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Корици`)
};

const ru_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обложки`)
};

const uk_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обкладинки`)
};

const ar_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأغلفة`)
};

const hi_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कवर`)
};

const th_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปก`)
};

const ja_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カバー`)
};

const zh_cn2_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`封面`)
};

const zh_hant1_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`封面`)
};

const ko_offerdetail_media_covers1 = /** @type {(inputs: Offerdetail_Media_Covers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커버`)
};

/**
* | output |
* | --- |
* | "Covers" |
*
* @param {Offerdetail_Media_Covers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_media_covers1 = /** @type {((inputs?: Offerdetail_Media_Covers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Media_Covers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_media_covers1(inputs)
	if (locale === "ms") return ms_offerdetail_media_covers1(inputs)
	if (locale === "da") return da_offerdetail_media_covers1(inputs)
	if (locale === "de") return de_offerdetail_media_covers1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_media_covers1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_media_covers1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_media_covers1(inputs)
	if (locale === "fil") return fil_offerdetail_media_covers1(inputs)
	if (locale === "fr") return fr_offerdetail_media_covers1(inputs)
	if (locale === "it") return it_offerdetail_media_covers1(inputs)
	if (locale === "hu") return hu_offerdetail_media_covers1(inputs)
	if (locale === "nl") return nl_offerdetail_media_covers1(inputs)
	if (locale === "no") return no_offerdetail_media_covers1(inputs)
	if (locale === "pl") return pl_offerdetail_media_covers1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_media_covers1(inputs)
	if (locale === "pt") return pt_offerdetail_media_covers1(inputs)
	if (locale === "ro") return ro_offerdetail_media_covers1(inputs)
	if (locale === "fi") return fi_offerdetail_media_covers1(inputs)
	if (locale === "sv") return sv_offerdetail_media_covers1(inputs)
	if (locale === "vi") return vi_offerdetail_media_covers1(inputs)
	if (locale === "tr") return tr_offerdetail_media_covers1(inputs)
	if (locale === "cs") return cs_offerdetail_media_covers1(inputs)
	if (locale === "bg") return bg_offerdetail_media_covers1(inputs)
	if (locale === "ru") return ru_offerdetail_media_covers1(inputs)
	if (locale === "uk") return uk_offerdetail_media_covers1(inputs)
	if (locale === "ar") return ar_offerdetail_media_covers1(inputs)
	if (locale === "hi") return hi_offerdetail_media_covers1(inputs)
	if (locale === "th") return th_offerdetail_media_covers1(inputs)
	if (locale === "ja") return ja_offerdetail_media_covers1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_media_covers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_media_covers1(inputs)
	return ko_offerdetail_media_covers1(inputs)
});
export { offerdetail_media_covers1 as "offerDetail.media.covers" }